module.exports = __webpack_public_path__ + "a74777af5c081053b657afb43d91c8bb.png";